// Homepage entry. Designer's HTML drives the page; this file boots the
// shared site helpers and runs loadConfig so brand + i18n apply.
import './site';
import { loadConfig } from '../envConfig';

void loadConfig();
